import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { TranslocoModule } from '@jsverse/transloco';
import {
  ACTIVITY_LOG_STATUS_TAG_COLOR,
  ActivityLogList,
  ActivityLogPagination,
} from '@keeps-platform-frontend-workspace/kp-keeps';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { constants } from '../../constants';
import { KpPluralizeTranslatePipe } from '../../pipes';
import { KpCardTagComponent } from '../kp-card-tag';

@Component({
  selector: 'kp-activity-log-list',
  imports: [
    CommonModule,
    MatTableModule,
    TranslocoModule,
    MatIconModule,
    MatButtonModule,
    NgxSkeletonLoaderModule,
    MatPaginatorModule,
    KpCardTagComponent,
    KpPluralizeTranslatePipe,
  ],
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        position: relative;
        overflow-y: scroll;
        height: 0;
      }
    `,
  ],
  templateUrl: './kp-activity-log-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpActivityLogListComponent {
  vm = input<ActivityLogList>();
  pageChanged = output<Partial<ActivityLogPagination>>();
  export = output<string>();

  protected readonly PAGE_SIZE_OPTIONS = constants.defaultPageSizeOptions;
  protected readonly itemsLoaderTheme = { width: '100%', borderRadius: '0', height: '81px' };
  protected readonly displayedColumns: string[] = ['date', 'time', 'user', 'action', 'status', 'menu'];
  protected readonly statusTagColor = ACTIVITY_LOG_STATUS_TAG_COLOR;

  onPageChange(event: PageEvent): void {
    const currentPage = event.pageIndex + 1;
    this.pageChanged.emit({ currentPage, perPage: event.pageSize });
  }

  onExport(id: string): void {
    this.export.emit(id);
  }
}
